import axios from "@/api/axiosInstance";
import { PublishLibraryModuleResponse } from "./types";

export const publishLibraryModule = async (
  uuid: string,
): Promise<PublishLibraryModuleResponse> => {
  const response = await axios.patch<PublishLibraryModuleResponse>(
    `/api/private/learning-center/module-library/${uuid}/publish`,
  );
  return response.data;
};
